export default {
      id: "icon-card-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-card",
      toString: function () {
        return this.url;
      }
    }